<div class="notification-bar notification-bar--{{type}}">
    <mat-icon class="icon icon--{{type}}">
        error
    </mat-icon>
    <p appParagraph>
        <ng-content />
    </p>
</div>
